import { render } from "./pot-salary-sum.vue?vue&type=template&id=abb35e74"
import script from "./pot-salary-sum.vue?vue&type=script&lang=js"
export * from "./pot-salary-sum.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/pot/pot-salary-sum.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "abb35e74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('abb35e74', __exports__)) {
    api.reload('abb35e74', __exports__)
  }
  
  module.hot.accept("./pot-salary-sum.vue?vue&type=template&id=abb35e74", () => {
    api.rerender('abb35e74', render)
  })

}


export default __exports__